export default [
  {
    path: '/rental/report/MY_010/home_rental_charges',
    name: 'MY_010_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_010_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_010/income_develop',
    name: 'MY_010_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_010_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_010/rental_charges',
    name: 'MY_010_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_010_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_010/income_others',
    name: 'MY_010_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_010_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_010/balance_due_home_rental',
    name: 'MY_010_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_010_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
